export const proofOfAddressTypes = [
  {
    label: "Recibo del agua",
    value: "water_bill",
    description: "SIAPA, CESPT u organismo local",
  },
  {
    label: "Recibo de la luz",
    value: "electricity_bill",
    description: "CFE o compañía local",
  },
  {
    label: "Predial",
    value: "predial",
    description: "Recibo de impuesto predial",
  },
  {
    label: "Recibo de comunicaciones",
    value: "communications_bill",
    description: "Telmex, Totalplay, Izzi, etc.",
  },
];

export const proofOfAddressTypesMap: any = {
  water_bill: "Recibo del agua",
  electricity_bill: "Recibo de la luz",
  predial: "Predial",
  communications_bill: "Recibo de comunicaciones (Telmex, Totalplay, etc.)",
};

export const labelProofOfAddressOptions: any = {
  tenant: "inquilino",
  guarantor: "obligado solidario",
  company: "la empresa",
};
